import { AssetDto, GreekSetDto, MarginAccountDto } from "../hooks/binance-options-data-service/types/MarginAccountDto";
import { Asset, GreekSet, MarginAccount } from "../types/MarginAccount";

export function mapMarginAccount(dto: MarginAccountDto): MarginAccount {
    return {
        timestamp: dto.time,
        canTrade: dto.canTrade,
        canDeposit: dto.canDeposit,
        canWithdraw: dto.canWithdraw,
        reduceOnly: dto.reduceOnly,

        assets: dto.asset.map(mapAsset),
        greekSets: dto.greek.map(mapGreekSet),
    };
}

function mapAsset(dto: AssetDto): Asset {
    return {
        asset: dto.asset,
        marginBalance: dto.marginBalance,
        equity: dto.equity,
        available: dto.available,
        initialMargin: dto.initialMargin,
        maintenanceMargin: dto.maintMargin,
        unrealizedPnl: dto.unrealizedPNL,
        adjustedEquity: dto.adjustedEquity,
    };
}

function mapGreekSet(dto: GreekSetDto): GreekSet {
    return {
        underlying: dto.underlying,
        delta: dto.delta,
        theta: dto.theta,
        gamma: dto.gamma,
        vega: dto.vega,
    };
}
